const PRODUCTION_API_URL = 'https://api.v2.odontogroup.com.br';
const LOCAL_API_URL = process.env.REACT_APP_OG_API_URL || PRODUCTION_API_URL;
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

type PublicEnv = Record<string, string | undefined>;

function getRuntimeEnv(): PublicEnv {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__ENV__ || {};
}

function isLocalPage(): boolean {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV !== 'production';
  }

  return LOCAL_HOSTS.has(window.location.hostname);
}

function normalizeUrl(value: string): string {
  const normalized = value.trim().replace(/\/+$/, '');

  if (!normalized) {
    return '';
  }

  try {
    return new URL(normalized).toString().replace(/\/+$/, '');
  } catch {
    return '';
  }
}

function isLocalUrl(value: string): boolean {
  try {
    return LOCAL_HOSTS.has(new URL(value).hostname);
  } catch {
    return false;
  }
}

export function getPublicEnv(key: string, fallback = ''): string {
  const runtimeValue = getRuntimeEnv()[key];
  const buildValue = process.env[key];

  const value = isLocalPage()
    ? buildValue || runtimeValue || fallback
    : buildValue || runtimeValue || fallback;

  return value.trim();
}

function resolveApiBaseUrl(): string {
  const fallbackUrl = isLocalPage() ? LOCAL_API_URL : PRODUCTION_API_URL;
  const configuredUrl = normalizeUrl(getPublicEnv('REACT_APP_OG_API_URL'));

  if (!configuredUrl) {
    return fallbackUrl;
  }

  if (!isLocalPage() && isLocalUrl(configuredUrl)) {
    console.warn(
      `REACT_APP_OG_API_URL apontava para ${configuredUrl} em produção. Usando ${PRODUCTION_API_URL}.`,
    );
    return PRODUCTION_API_URL;
  }

  return configuredUrl;
}

export const BASE_URL = resolveApiBaseUrl();
export const API_BASE_URL = BASE_URL;

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_URL}${normalizedPath}`;
}
